import EDataTable6 from './EDataTable6'

export default EDataTable6
